<template>
    <DriversOverTimeChart
        :title="`Top Drivers of ${getLabel('reduced_productivity').value}`"
        subtitle="Key factors limiting organizational efficiency"
        over-time-subtitle-prefix="Users Discussing"
        :drivers="drivers"
        :is-loading="isFetchingFilters || isFetching" />
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import DriversOverTimeChart from "~vue/ClientAnalytics/DriversOverTimeChart.vue";
import { getURLParamsFromFilters } from "~vue/ClientAnalytics/filters/helpers";
import type { DriversOverTimeResponse, SelectedFilters } from "~vue/ClientAnalytics/types";
import { useCustomLabels } from "~vue/composables/useCustomLabels";
import { computed, watch } from "vue";

const getLabel = useCustomLabels("client_analytics.insights");

const { filters = {}, isFetchingFilters = false } = defineProps<{
    filters?: SelectedFilters;
    isFetchingFilters?: boolean;
}>();

const url = computed(() => {
    const params = getURLParamsFromFilters(filters);
    return `/api/client-analytics/reduced-productivity-drivers/?` + params.toString();
});

const { data, isFetching, statusCode } = useFetch(url, { immediate: true, refetch: true }).json<DriversOverTimeResponse>();

const emit = defineEmits<{ hasKAnonError: [hasError: boolean] }>();

watch(statusCode, (newStatusCode) => emit("hasKAnonError", newStatusCode === 451), { immediate: true });

const PRODUCTIVITY_COLORS = ["#7AA2F7", "#CBE48E", "#C1A3FF", "#68D1D6", "#F6937F", "#FBBFF4"];

const drivers = computed(() => {
    if (!data.value || data.value.error) {
        return [];
    }
    return data.value.drivers.map((driver, index) => ({
        ...driver,
        // Note that colors are mapped here before any sorting in the chart component so that the
        // driver colors remain consistent regardless of their values.
        color: PRODUCTIVITY_COLORS[index % PRODUCTIVITY_COLORS.length],
    }));
});
</script>
